import { cloneElement, type ReactElement, type ReactNode } from 'react';

export default function ProviderContainer({ providers, children }: { providers: ReactElement[]; children?: ReactNode }) {
  let node = children;

  for (const provider of [...providers].reverse()) {
    node = cloneElement(provider, {}, node);
  }

  return <>{node}</>;
}
